import {
    FETCH_INSIGHTS_LIST,
    FETCH_INSIGHTS_LIST_FETCHING,
    FETCH_INSIGHTS_LIST_SUCCESS,
    FETCH_INSIGHTS_LIST_FAIL
} from 'actions/ActionTypes.js';

const INITIAL_STATE = {
    data: [],
    insightsListFetching: false,
    insightsListFetchFail: false
};

// ======= Fetching Handlers =======
const fetchInsightsListFetching = (state, action) => {
    return {
        data: state.data,
        insightsListFetching: true,
        insightsListFetchFail: false
    };
};

const fetchInsightsListSuccess = (state, action) => {
    return {
        data: action.data,
        insightsListFetching: false,
        insightsListFetchFail: false
    };
};

const fetchInsightsListFail = (state, action) => {
    return {
        data: state.data,
        insightsListFetching: false,
        insightsListFetchFail: true
    };
};

// ======= Handler Assignments =======
const handlers = {
    [FETCH_INSIGHTS_LIST_FETCHING]: fetchInsightsListFetching,
    [FETCH_INSIGHTS_LIST_SUCCESS]: fetchInsightsListSuccess,
    [FETCH_INSIGHTS_LIST_FAIL]: fetchInsightsListFail
};

// ======= Default Action =======
export default function insightsList(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// ======= Actions =======
export function fetchInsightsList(evictCache) {
    return {
        type: FETCH_INSIGHTS_LIST,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

// ======= Selectors =======
export const getInsightsList = (state) => {
    return state.insightsList.data ? state.insightsList.data : null;
};

export const isInsightsListFetching = (state) => {
    return state.insightsList.insightsListFetching;
};

export const didInsightsListFetchFail = (state) => {
    return state.insightsList.insightsListFetchFail;
};
